import { tns } from '../../../node_modules/tiny-slider/src/tiny-slider';
import { qs, qsAll } from '../dom-helpers';

class HomeSlider {
  constructor() {
    if (!qs('.hero-banner__slider')) return;

    this.slider = null;

    this.homeSlidesContainer = qs('.hero-banner__slider');
    this.homePrevSlideBtn = qs('.hero-banner__nav-btn--prev');
    this.homeNextSlideBtn = qs('.hero-banner__nav-btn--next');
    this.slideContent = qs('.hero-banner__desc-box');

    this._run();
  }

  _run() {
    this._initSlider();
  }

  _updateSlideData() {
    const info = this.slider.getInfo();
    const currentIndex = info.index;
    const homeSlides = qsAll('.hero-banner__slide img');

    const slideData = homeSlides[currentIndex].dataset;

    this.slideContent.innerHTML = `
         <h1 class="primary-title hero-banner__title">${slideData.title}</h1>
         <h2 class="hero-banner__subtitle">${slideData.subtitle}</h2>
      
         <div class="hero-banner__btn-box">
            <a href="${slideData.btnUrl}" class="button-with-shadow hero-banner__btn">${slideData.btnTitle}</a>
         </div>
    `;
  }

  _initSlider() {
    const _this = this;

    this.slider = tns({
      controls: true,
      slideBy: 'page',
      container: _this.homeSlidesContainer,
      items: 1,
      nav: false,
      mouseDrag: true,
      disable: false,
      prevButton: _this.homePrevSlideBtn,
      nextButton: _this.homeNextSlideBtn,
      autoplayTimeout: (window.slidesDelay || 5) * 1000,
      autoplay: window.slidesDelay > 0,
      autoplayButtonOutput: false
    });

    this._updateSlideData();

    this.slider.events.on('indexChanged', () => this._updateSlideData());
  }

  stop() {
    this.slider.pause();
  }

  resume() {
    this.slider.play();
  }
}

export default HomeSlider;
